import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  errorMessage?: string | null
}

export const InsuranceServiceEmpty: FC<Props> = ({ errorMessage }) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <p className={clsx('bold-17', s.title)}>
        {errorMessage || t('insurance_info.flight_without_insurance')}
      </p>
      {!errorMessage && (
        <p className={clsx('regular-14', s.description)}>
          {t('insurance_info.flight_without_insurance_description')}
        </p>
      )}
    </div>
  )
}
